import {
  MACHINE_INFO_REQUEST,
  MACHINE_INFO_SUCCESS,
} from '@constants/UHEActionTypes';

const INIT_STATE = {
  table: {
    list: [],
    page: {},
  },
  loading: false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case MACHINE_INFO_REQUEST: {
      return { ...state, loading: true };
    }

    case MACHINE_INFO_SUCCESS: {
      const newState = { table: action.payload, loading: false };
      return { ...state, ...newState };
    }

    default:
      return state;
  }
};
